import React, { useEffect, useState } from "react";
import { Grid, Box, Typography } from "@material-ui/core";

import httpClient from "../../lib/httpClient";
import { DataGridCystellarTable } from "../util/DataGridCystellarTable";
import {
  addExportButton,
  isSingleSelectOperators,
  numberFilterOperators,
  stringFilterOperators,
  tableCellRender,
  fromStringToNumberParser,
} from "../util/tableUtils";
import { highlightRow } from "./kpiUtils";

export const OfficeMonthVisit = () => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [officeMonthVisitDataFetching, setOfficeMonthVisitDataFetching] = useState(false);
  const [officeMonthVisitData, setOfficeMonthVisitData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setOfficeMonthVisitDataFetching(true);
    httpClient()
      .get(`/kpi/officeMonthVisit`)
      .then((res) => res.data)
      .then(async (data) => {
        const dataWithId = data.map((item, index) => ({ id: index, ...item }));
        const dataMonths = [...new Set(data.map((item) => item.Month))];
        const monthValueOptions = dataMonths.map((month) => ({ value: month, label: month }));

        const fieldNames = Object.keys(data[0]);
        const cols = fieldNames.map((fieldName) => ({ field: fieldName, headerName: fieldName, flex: 1 }));
        const colsWithMonthFilter = cols.map((col) =>
          col.field === "Month"
            ? {
                ...col,
                type: "singleSelect",
                filterOperators: isSingleSelectOperators,
                valueOptions: monthValueOptions,
              }
            : col.field === "page"
              ? {
                  ...col,
                  filterOperators: stringFilterOperators,
                }
              : {
                  ...col,
                  valueParser: fromStringToNumberParser,
                  filterOperators: numberFilterOperators,
                  valueFormatter: (params) => tableCellRender(params.value?.toString()),
                },
        );

        setColumns(colsWithMonthFilter);

        setOfficeMonthVisitData(dataWithId);
        setOfficeMonthVisitDataFetching(false);
      });
  }, []);

  return (
    <Grid item xs={12} sm={12}>
      <Box mb={3}>
        <Typography variant="body1" gutterBottom>
          Office Month Visit
        </Typography>
        <DataGridCystellarTable
          rows={officeMonthVisitData}
          columns={columns}
          getRowId={(rowData) => rowData.id}
          loading={officeMonthVisitDataFetching}
          pageSizeOptions={[10, 15, 25]}
          paginationModel={paginationModel}
          onPaginationModelChange={(newPaginationModel) => setPaginationModel(newPaginationModel)}
          customToolbarComp={true}
          customToolbarWidgets={addExportButton("Office Month Visit")}
          getRowClassName={(params) => highlightRow(params, "Total")}
        />
      </Box>
    </Grid>
  );
};
